import React, { CSSProperties, MouseEventHandler, useContext } from 'react';
import ReactSVG from 'react-svg';
import './SendMessage.scss';
import { ThemeContext } from '../../store/ThemeProvider';
import { getPendantColor } from '../../utils/color';
import { formatCommentNumber } from '../../utils/util';

interface ISendMessage {
  onClick: MouseEventHandler;
  number?: number;
}

export default (props: ISendMessage) => {
  const { number } = props;
  const { backgroundColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(backgroundColor);
  return (
    <div className="send-message-wrapper">
      <ReactSVG
        src={require('../../svg/icon-message.svg')}
        className={'ignore-move send-message-svg'}
        style={{ backgroundColor: pendantBgColor, color: pendantIconColor }}
        onClick={props.onClick}
      />
      {!!number && (
        <div className="number">
          <div className="real-number">
            {formatCommentNumber(Number(number))}
          </div>
        </div>
      )}
    </div>
  );
};
